import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * プロジェクトビューの絞り込み・選択状態。ProjectsPage は他ビューへ移るとアンマウントされるため、
 * 選択をコンポーネントの外に置いて画面を行き来しても保つ。
 */
interface ProjectFilterState {
	/** プロジェクト一覧にアーカイブ済みを含めるか。閲覧者の好みなので永続化する。 */
	includeArchived: boolean;
	setIncludeArchived: (includeArchived: boolean) => void;
	/**
	 * 最後に表示したプロジェクトの ID。サイドバーから ID なしの /projects へ戻ったときに
	 * 先頭プロジェクトへ飛ばず、直前の選択を復元するために使う。
	 */
	lastProjectId: string | null;
	setLastProjectId: (projectId: string) => void;
}

export const useProjectFilterStore = create<ProjectFilterState>()(
	persist(
		(set) => ({
			includeArchived: false,
			setIncludeArchived: (includeArchived) => set({ includeArchived }),
			lastProjectId: null,
			setLastProjectId: (lastProjectId) => set({ lastProjectId }),
		}),
		{
			name: "izanagi-project-filter",
			partialize: (state) => ({
				includeArchived: state.includeArchived,
				lastProjectId: state.lastProjectId,
			}),
		},
	),
);
